"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _HalfPieChartComponent["default"];
  }
});

var _HalfPieChartComponent = _interopRequireDefault(require("./HalfPieChartComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }